import React from 'react';
import PropTypes from 'prop-types';
import { Input, Button, Icon, Row, Col, Form } from 'antd';
import QueueAnim from 'rc-queue-anim';

// import { NHFetch, NHMultiSelect, NHSelect } from 'xgui-for-react';
import NHFetch from '../../utils/NHFetch';
import NHMultiSelect from "../common/NHMultiSelect";
import NHSelect from "../common/NHSelect";


const FormItem = Form.Item;

// 每行查询条件个数（要能被24整除）
const colNum = 4;


/**
 * 搜索栏
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2019-05-24 
 * Version: 1.0
 * Modify log:
 */
class SearchComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            expand: false,
            xyxxData: [],
            zyxxData: [],
            bjxxData: []
        }
    }

    componentDidMount() {
        NHFetch('api/sm-student/common/getSelectOptionDataByFilter', 'GET', { tag: 'xy', filter: '' })
            .then(res => {
                if (res) {
                    this.setState({ xyxxData: res.data ? res.data : [] });
                }
            })
    }

    //部门信息选择回调
    handleXyxxChange = (value) => {
        const { getFieldValue, setFieldsValue } = this.props.form;
        if (value && value.length > 0) {

            NHFetch('api/sm-student/common/getSelectOptionDataByFilter', 'GET', { tag: 'zy', filter: value.toString() })
                .then(res => {
                    if (res) {
                        let zyids = getFieldValue('zyid');
                        if (zyids && res.data && zyids.length > 0) {
                            let newData = res.data.map(item => item.VALUE);
                            newData = new Set(newData);
                            let newZyids = zyids.filter(item => newData.has(item));
                            setFieldsValue({ zyid: newZyids });
                            this.handleZyxxChange(newZyids);
                        }
                        this.setState({ zyxxData: res.data ? res.data : [] });
                    }
                })

        } else {
            setFieldsValue({ zyid: [], bjid: [] });
            this.setState({ zyxxData: [], bjxxData: [] });
        }

    }

    //专业信息选择回调
    handleZyxxChange = (value) => {
        const { getFieldValue, setFieldsValue } = this.props.form;
        if (value && value.length > 0) {

            NHFetch('api/sm-student/common/getSelectOptionDataByFilter', 'GET', { tag: 'bj', filter: value.toString() })
                .then(res => {
                    if (res) {
                        let bjids = getFieldValue('bjid');
                        if (bjids && res.data && bjids.length > 0) {
                            let newData = res.data.map(item => item.VALUE);
                            newData = new Set(newData);
                            let newBjids = bjids.filter(item => newData.has(item));
                            setFieldsValue({ bjid: newBjids });
                        }
                        this.setState({ bjxxData: res.data ? res.data : [] });
                    }
                })

        } else {
            setFieldsValue({ bjid: [] });
            this.setState({ bjxxData: [] });
        }
    }

    /**
     * * 查询
     * @memberof SearchComponent
     */
    onSearch = () => {

        const { onSearch } = this.props;
        if (onSearch) {
            onSearch();
        }
    }

    /**
     * * 在搜索框按下回车键的回调
     * @memberof SearchComponent
     */
    onPressEnter = () => {
        const { onSearch } = this.props;
        if (onSearch) {
            onSearch();
        }
    }

    /**
     * * 重置
     * @memberof SearchComponent
     */
    onReload = () => {

        const { resetFields } = this.props.form;
        resetFields();

        const onReload = this.props.onReload;
        if (onReload) {
            onReload();
        }
    }

    /**
     * * 收起展开高级搜索栏
     * @memberof SearchComponent
     */
    toggle = () => {
        const { expand } = this.state;
        const { setFieldsValue, resetFields } = this.props.form;
        if (!expand) {
            setFieldsValue({ searchValue: undefined });
        } else {
            resetFields();
            setFieldsValue({ searchValue: '' });
        }
        this.setState({ expand: !expand });
    }

    getFields = () => {
        const { getFieldDecorator } = this.props.form;
        const { xyxxData, zyxxData, bjxxData } = this.state;

        // 有无照片下拉选择数据
        const ywzp = [{ value: '', label: '请选择...' }, { value: '1', label: '有' }, { value: '0', label: '无' }];

        let colSpan = parseInt(24 / colNum, 0);

        const children = [
            <Col span={colSpan} key={'bm'}>
                <FormItem label={`学院`}>
                    {getFieldDecorator(`bmid`)(<NHMultiSelect dataSource={xyxxData} onChange={this.handleXyxxChange} />)}
                </FormItem>
            </Col>,
            <Col span={colSpan} key={'zy'}>
                <FormItem label={`专业`}>
                    {getFieldDecorator(`zyid`)(<NHMultiSelect dataSource={zyxxData} onChange={this.handleZyxxChange} />)}
                </FormItem>
            </Col>,
            <Col span={colSpan} key={'bj'}>
                <FormItem label={`班级`}>
                    {getFieldDecorator(`bjid`)(<NHMultiSelect dataSource={bjxxData} />)}
                </FormItem>
            </Col>,
            <Col span={colSpan} key={'nj'}>
                <FormItem label={`当前年级`}>
                    {getFieldDecorator(`nj`)(<NHSelect sign={'zhxg_xsxx_nj_select'} />)}
                </FormItem>
            </Col>,
            <Col span={colSpan} key={'xb'}>
                <FormItem label={`性别`}>
                    {getFieldDecorator(`xb`)(<NHSelect sign={'DMK_XTGL_XBM'} />)}
                </FormItem>
            </Col>,
            <Col span={colSpan} key={'xslbm'}>
                <FormItem label={`学生类别`}>
                    {getFieldDecorator(`xslbm`)(<NHSelect sign={'DMK_XTGL_XSLBM'} />)}
                </FormItem>
            </Col>,
            <Col span={colSpan} key={'zp'}>
                <FormItem label={`有无照片`}>
                    {getFieldDecorator(`zp`)(<NHSelect dataSource={ywzp} />)}
                </FormItem>
            </Col>,
            <Col span={colSpan} key={'rxnf'}>
                <FormItem label={`入学年级`}>
                    {getFieldDecorator(`rxnf`)(<NHSelect sign={'zhxg_xsxx_rxnj_select'} />)}
                </FormItem>
            </Col>
        ];
        return children;
    }

    render() {

        const { expand } = this.state;

        const { searchParams } = this.props;

        const { getFieldDecorator } = this.props.form;

        let searchRow = [];

        for (let i = 0; i < Math.ceil(this.getFields().length / colNum); i++) {
            searchRow.push(
                <Row key={i} gutter={24}>
                    <QueueAnim type={['top']}>
                        {expand ? this.getFields().slice(i * colNum, (i + 1) * colNum) : null}
                    </QueueAnim>
                </Row>
            );
        }

        return (
            <div>
                <Form>
                    {searchRow}
                    <Row gutter={24}>
                        <Col span={8}>
                            {expand ? '':
                            <FormItem label={`全部`}>
                                {getFieldDecorator(`searchValue`, {
                                })(
                                    <Input
                                        placeholder={'搜索学号、姓名、班级等...'}
                                        onPressEnter={this.onPressEnter} />
                                )}
                            </FormItem>
                            }
                        </Col>
                        <Col span={8}>
                            <FormItem>
                                <Button type={'primary'} onClick={this.onSearch}>查询</Button>
                                <Button style={{ marginLeft: 10 }} onClick={this.onReload}>重置</Button>
                                <a style={{ marginLeft: 10, fontSize: 14 }} onClick={this.toggle}>
                                    {expand ? <span>收起<Icon type={'up'} /></span> : <span>展开<Icon type={'down'} /></span>}
                                </a>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }

}

SearchComponent.defaultProps = {
    searchParams: {}
}

SearchComponent.propTypes = {
    onSearch: PropTypes.func,
    onReload: PropTypes.func,
    searchParams: PropTypes.object,
}

const WrappedSearchComponent = Form.create({})(SearchComponent);
export default WrappedSearchComponent;


// WEBPACK FOOTER //
// ./components/studentPhotoMng/search.js